import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import { CardMedia } from '@mui/material';
import CardContainer from '../../utils/CardContainer';
import ReadMoreText from '../../utils/ReadMore';
import { MovingText } from '../../utils/MovingText';
import { ImagePath, ImageRelativePath, Website_Url, Constants } from '../../constants';



const ShareCoursesCard = ({ item }) => {
    const { type, slug } = item;
    const message = "Check out this awesome website!";

    const url = type === 6 ? `${Website_Url}OnlineCourseDetail/${slug}` : `${Website_Url}CoursesDetail/${slug}`;
    const encodedMessage = encodeURIComponent(`${message} ${url}`);
    const handleWhatsAppShare = () => {
        window.open(
            `https://wa.me/?text=${encodedMessage}`,
            '_blank',
            'noopener,noreferrer'
        );
    };
    return (
        <>
            <CardContainer>
                <CardMedia
                    sx={{
                        width: { lg: "30%", xs: "100%" },
                        borderRadius: "15px",
                        height: { lg: "auto", xs: "200px" }
                    }}
                    image={item?.cover_image ? `${ImagePath}${ImageRelativePath}${item?.cover_image}` : Constants.customImages.DefaultImage}

                />
                <CardContent sx={{ width: { lg: "70%", xs: "100%" }, px: { lg: "15px", xs: "0" } }}>
                    <MovingText variant={"h5"} text={item?.title} width={"100%"} />
                    <ReadMoreText text={item?.short_description} />
                    <Button variant='contained' fullWidth onClick={handleWhatsAppShare}>Share</Button>
                </CardContent>
            </CardContainer>
        </>
    )
}

export default ShareCoursesCard